import myStorage from 'src/utils/my.storage';
import request from 'src/utils/request';

export function asyncDispatchEvent(eventName, data = {}, timeout = 30000) {
    console.log('[DispatchEvent]', eventName, data);

    
    const eventResponse = `${eventName}Response`;
    return new Promise((resolve, reject) => {
        function handleEventResponse(event) {
            // console.log(`[${eventResponse}]`, event.detail);
            // const logEvents  = ['getAccessToken', 'createCanvasPhotos', 'getPageInfo'];
            // if (logEvents.includes(eventName)){
            //     request.post('/public/logs', {
            //         eventName,
            //         request: data,
            //         response: event.detail
            //     });
            // }
            resolve(event.detail);
            window.removeEventListener(eventResponse, handleEventResponse);
        }

        window.addEventListener(eventResponse, handleEventResponse);

        const event = new CustomEvent(eventName, {
            detail: data,
        });

        window.dispatchEvent(event);
        if (timeout > 0) {
            setTimeout(() => {
                resolve({
                    error: 'Timeout',
                    message: `Timeout after ${timeout}ms`,
                });
                window.removeEventListener(eventName, handleEventResponse);
            }, timeout);
        }

    });
}

export async function getAccessToken() {
    return myStorage.remember('accessToken', async () => {
        const response = await asyncDispatchEvent('getAccessToken');
        return response.token;
    });
}

export async function getPageVideos(data) {

    const {
        token,
        page_id,
        limit,
        ads_token,
        act_id,
    } = data;

    return await asyncDispatchEvent('get_list_video_page_with_thumb', {
        ads_token,
        page_id,
        limit,
        act_id,
        token,
    }, 60 * 1000);
}

export async function getPages({ token }) {
    return await asyncDispatchEvent('getPages', { token });
}

export async function getAdAccounts({ token }) {
    return await asyncDispatchEvent('getListAdsAccounts', { token });
}

export function show_permalink_url(url) {
    return 'https://www.facebook.com/' + url;
}

export async function getCsrfToken({ token = '' }) {
    return await asyncDispatchEvent('getCsrfToken', { token });
}

export async function getAdsToken({ token, act_id }) {
    return await asyncDispatchEvent('getAdToken', { token, act_id });
}

export async function getPagesWithToken({ token }) {
    return await asyncDispatchEvent('getPagesWithToken', { token });
}

export async function switchFanPageById({ pageId, token = '' }) {
    return await asyncDispatchEvent('switchFanPageById', {
        page_id: pageId, token,
    });
}

export async function getPageInfo({ pageId, token }) {
    let key = `page_${pageId}`;
    return await myStorage.remember(key, async () => {
        const response = await asyncDispatchEvent('getPageInfo', { token, pageId });
        return response ?? {};
    }, null);

}

export async function getPageToken({ pageId, token }) {
    const pageInfo = await getPageInfo({ pageId, token });
    return pageInfo.access_token ?? '';
}

export async function pageCreatePost({ token, pageId, body }) {
    return await asyncDispatchEvent('pageCreatePost', { token, pageId, body });
}


export async function createCanvasPhoto({ token, pageId, body }) {
    return await asyncDispatchEvent('createCanvasPhoto', { token, pageId, body });
}

export function convertImageUrlToBlob(url) {
    return fetch(url).then((res) => res.blob());
}


/**
 * @typedef {Object} CanvasPhoto
 * @property {string} images
 * @property {string} ads_token
 * @property {string} acc_id
 * @property {string} page_id
 * @property {string} page_token
 * @property {string} open_url_action
 * @param {CanvasPhoto} data
 * @returns {Promise<any>}
 * */
export async function createCanvasPhotos(data) {
    return await asyncDispatchEvent('createCanvasPhotos', data, 60 * 1000);
}


export async function postVideo(data = {}) {
    return await asyncDispatchEvent('postVideo', data, 60 * 1000);
}

/**
 * Upload video to Facebook Page using Video API
 * Based on: https://developers.facebook.com/docs/video-api/guides/publishing/
 * @param {Object} data - Upload data
 * @param {File} data.video_file - Video file
 * @param {string} data.title - Video title
 * @param {string} data.description - Video description
 * @param {string} data.page_id - Page ID
 * @param {string} data.page_token - Page access token
 * @param {string} data.access_token - User access token
 * @returns {Promise<Object>} Upload response
 */
export async function uploadVideoToPageAPI(data = {}) {
    return await asyncDispatchEvent('uploadVideoToPageAPI', {
        video_file: data.video_file,
        title: data.title,
        description: data.description,
        page_id: data.page_id,
        page_token: data.page_token,
        access_token: data.access_token
    }, 300 * 1000); // 5 minutes timeout for video upload
}

/**
 * Check video status and details
 * @param {Object} data - Video check data
 * @param {string} data.video_id - Video ID
 * @param {string} data.access_token - Access token
 * @returns {Promise<Object>} Video details
 */
export async function checkVideoStatus(data = {}) {
    return await asyncDispatchEvent('checkVideoStatus', {
        video_id: data.video_id,
        access_token: data.access_token
    }, 30 * 1000);
}